import ArrowForward from "@mui/icons-material/ArrowForward";
import { Box, Link, Typography } from "@mui/material";
import type * as React from "react";
import { COLORS } from "components/v3/Theme/colors";
import {
  GENOMIC_LIFE_PUBLIC_PRIVACY_POLICY_URL,
  GENOMIC_LIFE_PUBLIC_TERMS_OF_USE_URL
} from "constants/externalPathConstants";

const UnpaidInviteCompleteSummaryCard: React.FC = () => {
  return (
    <Box
      sx={{
        bgcolor: COLORS.LIGHT_GRAY,
        borderRadius: "16px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        gap: 2,
        maxWidth: { lg: 360, xs: "100%" },
        p: { lg: 3, xs: 2.5 },
        width: "100%"
      }}
    >
      <Typography component="h2" variant="h6_black" sx={{ m: 0 }}>
        Genomic Life Complete
      </Typography>
      <Box>
        <Typography component="p" variant="body_dark_gray" sx={{ m: 0 }}>
          Your yearly cost
        </Typography>
        <Typography
          component="p"
          sx={{
            fontVariantNumeric: "tabular-nums",
            letterSpacing: "0.02em",
            m: 0,
            mt: 0.5,
            typography: { md: "h5_accent2", xs: "h5_accent2" }
          }}
        >
          $ 299.00
        </Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        <Box sx={{ alignItems: "flex-start", display: "flex", gap: 1.5 }}>
          <ArrowForward
            sx={{
              color: COLORS.PRIMARY,
              flexShrink: 0,
              fontSize: 18,
              mt: 0.35
            }}
          />
          <Typography component="p" variant="body_dark_gray" sx={{ m: 0 }}>
            Annual plan required.
          </Typography>
        </Box>
        <Box sx={{ alignItems: "flex-start", display: "flex", gap: 1.5 }}>
          <ArrowForward
            sx={{
              color: COLORS.PRIMARY,
              flexShrink: 0,
              fontSize: 18,
              mt: 0.35
            }}
          />
          <Typography component="p" variant="body_dark_gray" sx={{ m: 0 }}>
            Membership automatically renews annually and is subject to our
            refund and cancellation policy.
          </Typography>
        </Box>
        <Typography component="p" variant="body_dark_gray" sx={{ m: 0, mt: 0.5 }}>
          Please see our{" "}
          <Link
            href={GENOMIC_LIFE_PUBLIC_TERMS_OF_USE_URL}
            rel="noopener noreferrer"
            target="_blank"
            underline="always"
            sx={{
              color: COLORS.DARK_GRAY,
              textDecorationColor: COLORS.DARK_GRAY,
              typography: "body_dark_gray"
            }}
          >
            Terms of Use
          </Link>{" "}
          and{" "}
          <Link
            href={GENOMIC_LIFE_PUBLIC_PRIVACY_POLICY_URL}
            rel="noopener noreferrer"
            target="_blank"
            underline="always"
            sx={{
              color: COLORS.DARK_GRAY,
              textDecorationColor: COLORS.DARK_GRAY,
              typography: "body_dark_gray"
            }}
          >
            Privacy Policy
          </Link>{" "}
          for details.
        </Typography>
      </Box>
    </Box>
  );
};

export default UnpaidInviteCompleteSummaryCard;
